<template>
  <div>
    <commonheader></commonheader>
    <div class="content">
        <div class="crumbsNavCont">
            <p class="crumbsNav">位置：首页>协会动态</p>
             <div class="searchBox">
                 <search></search>
             </div>
        </div>
        <div class="subPageCont">
            <div class="subNewList fl">
                <commonnewlist :listData="listData"  :newListStyle3="true"></commonnewlist>
            </div>


            <div class="contactUsBox fr">
                <contactus :contactStyle1="true"></contactus>    
            </div>


        </div>
        
          <!--分页-->
            <div class="paginationBox">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="listTotal"
                    :page-size="15"
                    @current-change="handleCurrentChange"               
                    @prev-click="handlePrevClick"
                    @next-click="handleNextClick" >
                </el-pagination>
            </div>  

    </div>


   <commonfooter></commonfooter>

   


  </div>
</template>

<script>

import commonheader from './common/commonHeader.vue' //头部组件
import commonfooter from './common/commonFooter.vue' //底部组件
import commonnewlist from './common/commonNewList.vue' //新闻列表组件
import search from './common/search.vue' //搜索组件
import contactus from './common/contactUs.vue' //右侧联系我们组件

export default {
  name: "index",
  components: {
    commonheader,
    commonfooter,
    commonnewlist,
    search,
    contactus,
  },
  data() {
    return {
       listData:[],
       currentPage:1,
       listTotal: 0,

    };
  },
  mounted() {  
        
  },
  methods: {
    handlePrevClick(val) {
        console.log('当前显示页===', val)
        this.currentPage = val
        this.$route.query && this.$route.query.id &&  this.initNewList( this.$route.query.id);
    },

    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val
        this.$route.query && this.$route.query.id &&  this.initNewList( this.$route.query.id);
    },
    handleNextClick(val) {
        console.log('当前显示页===', val)
        this.currentPage = val
        this.$route.query && this.$route.query.id &&  this.initNewList( this.$route.query.id);
    },

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.content {
  width:1400px;
  margin: 0 auto;
  padding-bottom:40px;
}


.crumbsNavCont {
    height:70px;
    border-bottom:1px solid #D8D8D8;
    position: relative;
}
.crumbsNav {
    font-size:14px;
    color:#222;
    height:100%;
    line-height: 70px;
}

.subPageCont {
    overflow: hidden;
    margin-top:10px;
}
.searchBox {
    position:absolute;
    right:0;
    top:50%;
    transform: translateY(-50%);
}
.subNewList {
    width:1080px;
}

.contactUsBox {
    width:265px;
}

.paginationBox {
    margin-top:60px;
    text-align: center;
}






</style>


// WEBPACK FOOTER //
// src/components/notice.vue